/**
 * @freesewing/plugin-notches | v2.16.2
 * A FreeSewing plugin that provides front and back notch snippets
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var e={name:"@freesewing/plugin-notches",version:"2.16.2",hooks:{preRender:function(e){!1===e.attributes.get("freesewing:plugin-notches")&&(e.defs+='<g id="notch"><circle cy="0" cx="0" r="1.4" class="fill-note" /><circle cy="0" cx="0" r="2.8" class="note" /></g><g id="bnotch"><path d="M -1.1 -1.1 L 1.1 1.1 M 1.1 -1.1 L -1.1 1.1" class="note stroke-xl" /><circle cy="0" cx="0" r="2.8" class="note" /></g>',e.attributes.add("freesewing:plugin-notches","2.16.2"))}}};export default e;
//# sourceMappingURL=index.mjs.map
